export default __webpack_public_path__ + "static/media/mail.0a58d81a.svg";